// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    background-color: #e7f3ff;
    padding: 20px;
    border-radius: 8px; 
  }
  
  .container h3 {
    margin-bottom: 20px;
    font-size: 18px;
    color: #005b96; 
  }
  
  .table-headers {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    margin-bottom: 16px;
    font-weight: 600;
    color: #005b96;
  }
  
  .header-name {
    text-align: center;
  }
  
  .row {
    margin-bottom: 16px;
  }
  
  .divider {
    margin: 16px 0;
  }
  
  .input-container {
    border-radius: 25px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    display: flex;
    align-items: center;
  }
  
  .input-field {
    border-radius: 25px; 
    background-color: #fff;
  }
  
  .input-addon {
    color: #b0b0b0; 
    font-size: 0.8em; 
    padding: 0 10px;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }
  
  .dropdown-button {
    border-radius: 25px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/reportingtab/wastecontent.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".container {\n    background-color: #e7f3ff;\n    padding: 20px;\n    border-radius: 8px; \n  }\n  \n  .container h3 {\n    margin-bottom: 20px;\n    font-size: 18px;\n    color: #005b96; \n  }\n  \n  .table-headers {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 16px;\n    margin-bottom: 16px;\n    font-weight: 600;\n    color: #005b96;\n  }\n  \n  .header-name {\n    text-align: center;\n  }\n  \n  .row {\n    margin-bottom: 16px;\n  }\n  \n  .divider {\n    margin: 16px 0;\n  }\n  \n  .input-container {\n    border-radius: 25px;\n    border: 1px solid #d9d9d9;\n    background-color: #fff;\n    display: flex;\n    align-items: center;\n  }\n  \n  .input-field {\n    border-radius: 25px; \n    background-color: #fff;\n  }\n  \n  .input-addon {\n    color: #b0b0b0; \n    font-size: 0.8em; \n    padding: 0 10px;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n  }\n  \n  .dropdown-button {\n    border-radius: 25px;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
